import { createContext } from 'react';

export const LockSliderContext = createContext({
  lockSliderSetting: localStorage.getItem('lockSliderSetting') || 'auto',
  setLockSliderSetting: () => {}
});
